import React from 'react'
import dp from '../images/profiel-photo.png'
import 'animate.css';
import "./HeroSection.css";

export default function HeroSection() {
  return (
    <div>
    <div className='hero-section flex-row'>
        <div className="hero-socials">
              <a
                href="https://x.com/Kip__Emmanuel"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-x-twitter"></i>
              </a>
              <a
                href="https://github.com/Emmanuel-Deo"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-github"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/emmanuel-kipngetich-969204267/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin"></i>
              </a>
        </div> 
        <div className='hero-info'> 
            <div >  Emmanuel Kipngetich </div>
            <div >  GIS & Earth Observation Expert </div>
            <div > I leverage geospatial data to uncover insights, connecting technology with real-world challenges for Meaningful impact.</div>
            <div >  Geospatial Analysis | Mapping & Visualization </div>

        </div>

        <div className='hero-dp' > <img  src={dp} alt='dp'/></div>
      
   </div>

   <div className="arrow">
      <i className="fas fa-arrow-down-long"></i>
    </div>
    
    </div>
  )
}
